if (!Array.prototype.filter) {
	Array.prototype.filter = function (fun ) {
		"use strict";

		if (this === void 0 || this === null) {
			throw new TypeError();
		}
			

		var t = Object(this);
		var len = t.length >>> 0;
		if (typeof fun !== "function") {
			throw new TypeError();
		}
			

		var res = [];
		var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
		for (var i = 0; i < len; i++) {
			if (i in t) {
				var val = t[i];
				
				if (fun.call(thisArg, val, i, t)) {
					res.push(val);
				}
					
			}
		}

		return res;
	};
}
function FilterInputTextWord() {
	var allInput = $("input[type='text']");
	allInput.on('input', function() {
		var that = $(this);
		var textVal = that.val();
		if (textVal.indexOf(">") > -1 || textVal.indexOf("<") > -1) {
			textVal = textVal.replace(/(<|>)/g, "");
			that.val(textVal);
		}
	});
}


function consolelogwrite(obj) {
	try {
		console.log("%o", obj);
	} catch (e) {
	}
}

function setDocumentDomain() {
	if (location.href.indexOf('gigabyte.com') > -1 && $('#ChatContainer').find(".srm-content").length === 1) {
		document.domain = 'gigabyte.com';
	}
}

function resetDocumentDomain() {
	if (location.href.indexOf('gigabyte.com') > -1 && $('#ChatContainer').find(".srm-content").length === 1) {
		document.domain = document.location.hostname;
	}
}

function sleep(milliseconds) {
	var start = new Date().getTime();
	for (var i = 0; i < 1e7; i++) {
		if ((new Date().getTime() - start) > milliseconds) {
			break;
		}
	}
}

function replaceListModelImage(imgPath) {
	imgPath = imgPath.replace(/_sub\.jpg/g, "_mm.jpg").replace(/_sub\.png/g, "_mm.jpg");
	return imgPath;
}

function replaceListModelImageToPNG(imgPath) {
	imgPath = imgPath.replace(/_sub\.jpg/g, "_m.jpg").replace(/_sub\.png/g, "_m.png");
	return imgPath;
}

function ConvertToRtlString(strContent, isRtl) {
	if (isRtl && strContent) {
		strContent = strContent.replace("('", "|__").replace("')", "__|");
		strContent = strContent.replace("(", "&#x200F;(").replace(")", ")&#x200F;");
		strContent = strContent.replace("|__", "('").replace("__|", "')");

		strContent = strContent.replace("《'", "|__").replace("'》", "__|");
		strContent = strContent.replace("《", "&#x200F;《").replace("》", "》&#x200F;");
		strContent = strContent.replace("|__", "《'").replace("__|", "'》");
	}
	return strContent;
}

var CookieWithCountryCode = {
	//name 為cookie name 
	//value 為cookie 值
	//isUseGlobalDomain 為使用預設Domain "gigabyte.com"
	//days 為存入時間(若 與瀏覽器開啟時間一樣 請輸入空白 若取消cookie 請輸入-1) 
	//domainName 目前domain
	//Partial 無載入shared/Laynew 須帶入Global.countryCode判別國碼
	getDefaultCountryCode: function (countryCode) {

		var result = 'global';

		if (typeof (countryCode) === 'undefined') {
			if (typeof (window.CountryCode) !== 'undefined') {
				result = window.CountryCode;
			};
		} else {
			result = countryCode;
		}
		return result;
	},

	set: function (name, value, isUseGlobalDomain, days, countryCode, domainName) {

		var date, time, expiresString;

		if (typeof (name) === 'undefined') {
			name = "";
		}

		if (typeof (value) === 'undefined') {
			value = "";
		}

		if (typeof (days) === 'undefined' || days === '') {
			expiresString = "";
		}
		else {
			date = new Date();
			date.setTime(date.getTime() + days * (24 * 60 * 60 * 1000));
			time = date.toGMTString();
			expiresString = "; expires=" + time;
		}
		//console.log(time);
		if (typeof (domainName) === 'undefined') {
			//domainName = document.domain;
			domainName = document.location.hostname;
		}

		if (typeof (isUseGlobalDomain) !== 'undefined') {
			if (isUseGlobalDomain.toLowerCase() === 'true') {
				domainName = ".gigabyte.com";
			} else {
				//domainName = document.domain;
				domainName = document.location.hostname;
			}
		}

		var cookieCountryCode = this.getDefaultCountryCode(countryCode);

		//console.log(name /*+ "_"+ window.CountryCode*/ + "=" + value + "; domain=" + domainName + "; expires=" + time + "; path=/");
		if (typeof (name) !== 'undefined') {
			document.cookie = name + "_" + cookieCountryCode + "=" + value + "; domain=" + domainName + expiresString + "; path=/";
			//document.cookie = name + "=" + value + "; domain=" + domainName + expiresString + "; path=/";
		}
	},

	get: function (name, countryCode) {

		var cookieCountryCode = this.getDefaultCountryCode(countryCode);

		var arr = document.cookie.match(new RegExp("(^| )" + name + "_" + cookieCountryCode + "=([^;]*)(;|$)"));

		if (typeof (arr) !== 'undefined') {
			if (arr != null) {
				//fix unescape only decode ASCII error for compare model By Cody.Yang 2018/11/07
				return decodeURI(arr[2]);
			} else {
				return null;
			}
		} else {
			return null;
		}
	},

	getByKey: function (name, key, countryCode) {
		var cookieCountryCode = this.getDefaultCountryCode(countryCode);
		var cookieValue = this.get(name, cookieCountryCode);
		if (typeof (cookieValue) !== "undefined") {
			var jsonTemp = JSON.parse(cookieValue);
			if (typeof (jsonTemp) !== "undefined") {
				return jsonTemp[key];
			} else {
				return null;
			}
		} else {
			return null;
		}
	},

	
}
var QueryString = function () {
	// This function is anonymous, is executed immediately and 
	// the return value is assigned to QueryString!
	var query_string = {};
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		// If first entry with this name
		if (typeof query_string[pair[0]] === "undefined") {
			query_string[pair[0]] = pair[1];
			// If second entry with this name
		} else if (typeof query_string[pair[0]] === "string") {
			var arr = [query_string[pair[0]], pair[1]];
			query_string[pair[0]] = arr;
			// If third or later entry with this name
		} else {
			query_string[pair[0]].push(pair[1]);
		}
	}
	return query_string;
}();

var checkJSPluginExist = function (plugin_name, reload_url, depend_plugin_name) {
	if (typeof depend_plugin_name !== 'undefined') {
		window[depend_plugin_name][plugin_name] || document.write('<script src="' + reload_url + '">\x3C/script>');
	} else {
		window[plugin_name] || document.write('<script src="' + reload_url + '">\x3C/script>');
	}
	return true;
};
var SmoothScroll = function () {
	var $w = $(window);
	var $d = $(document);
	var scrollTop = 0;
	var mouse_wheel_finish = true;
	var MouseWheel = function (e) {
		var delta = (e.originalEvent.wheelDelta) ? (e.originalEvent.wheelDelta) : (e.originalEvent.detail * -120 / 3);
		scrollTop = (mouse_wheel_finish) ? $w.scrollTop() : scrollTop;		//when wheel start
		mouse_wheel_finish = false;		//mouse on wheeling
		scrollTop = (delta * -1) + scrollTop;		//calculate wheel scrollTop offset
		scrollTop = (scrollTop < 0) ? 0 : scrollTop;		//when on the top of page the offset is 0
		scrollTop = ($w.scrollTop() + $w.height() >= $d.height() && scrollTop + $w.height() >= $d.height()) ? $w.scrollTop() : scrollTop;	//when on the bottom of page the offset is $w.scrollTop
		//Run smooth animate
		$('html,body').stop().animate({
			scrollTop: scrollTop
		}, 500, function () {
			mouse_wheel_finish = true;		//finish mouse wheel
		});
		e.preventDefault();
		e.stopPropagation();
	};

	$('body').on({
		'mousewheel': MouseWheel,
		'DOMMouseScroll': MouseWheel
	});
};
var prevWidth = 0;

//全站使用cookie
var CookieAllWebsite = {
	//name 為cookie name 
	//value 為cookie 值
	//isUseGlobalDomain 為使用預設Domain "gigabyte.com"
	//days 為存入時間(若 與瀏覽器開啟時間一樣 請輸入空白 若取消cookie 請輸入-1) 
	//domainName 目前domain
	//Partial 無載入shared/Laynew 須帶入Global.countryCode判別國碼
	set: function (name, value, isUseGlobalDomain, days, countryCode, domainName) {

		var date, time, expiresString;

		if (typeof (name) === 'undefined') {
			name = "";
		}

		if (typeof (value) === 'undefined') {
			value = "";
		}

		if (typeof (days) === 'undefined' || days === '') {
			expiresString = "";
		}
		else {
			date = new Date();
			date.setTime(date.getTime() + days * (24 * 60 * 60 * 1000));
			time = date.toGMTString();
			expiresString = "; expires=" + time;
		}
		if (typeof (domainName) === 'undefined') {
			domainName = document.domain;
		}

		if (typeof (isUseGlobalDomain) !== 'undefined') {
			if (isUseGlobalDomain.toLowerCase() === 'true') {
				domainName = ".gigabyte.com";
			} else {
				domainName = document.domain;
			}
		}
		document.cookie = name + "=" + value + "; domain=" + domainName + expiresString + "; path=/";
		
	},

	get: function (name, countryCode) {

		var cookieCountryCode = 'global';

		if (typeof (countryCode) === 'undefined') {
			if (typeof (window.CountryCode) !== 'undefined') {
				cookieCountryCode = window.CountryCode;
			};
		} else {
			cookieCountryCode = countryCode;
		}

		var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));

		if (typeof (arr) !== 'undefined') {
			if (arr != null) {
				return unescape(arr[2]);
			} else {
				return null;
			}
		} else {
			return null;
		}
	}
}

/*判斷為iPad,部分iPad為iPAd OS，無法透過CheckIsMobile來判斷*/
var CheckIsNewVersionIPad = function () {
	window.isNewIPadOs = window.AuthenticatorAssertionResponse === undefined
		&& window.AuthenticatorAttestationResponse === undefined
		&& window.AuthenticatorResponse === undefined
		&& window.Credential === undefined
		&& window.CredentialsContainer === undefined
		&& window.DeviceMotionEvent !== undefined
		&& window.DeviceOrientationEvent !== undefined
		&& navigator.maxTouchPoints === 5
		&& navigator.plugins.length === 0
		&& navigator.platform !== "iPhone";
};


/*判斷為PC 或者 行動裝置，但已無法判斷部分iPad，需透過CheckIsNewVersionIPad()方式判斷*/
var CheckIsMobile = function () {
	window.isMobile = false;
	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
		|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
		window.isMobile = true;
	}
};
window.trrigerDialogfunction = function (type) {
	//console.log(type);
	switch (type) {
		case "livechat":
			SetLiveChat.Toogle('uselivechat');
			break;
	}
};

//確認瀏覽器是否符合vue
var BrowserIsOkayForVue = function () {
	var userAgent = navigator.userAgent;
	var IsOky = true;
	//ie 8 以下版本不符合
	if (userAgent.indexOf("MSIE") > -1) {
		var getVersionStr = getIEVersion(userAgent);
		if (getVersionStr < 9) {
			IsOky = false;
		}
	}
	
	return IsOky;
};

var getIEVersion = function (userAgent) {
	var msie = userAgent.indexOf("MSIE");
	if (msie > 0) {
		var ver = parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
		return ver;
	} else {
		return 0;
	}
};

var CheckUseRWDsizeNow = function (width) {
	if (typeof (width) === 'undefined') {
		width = 960;
	}
	
	var scrollBarWidth = window.isMobile || window.isNewIPadOs //部分iPad 沒有被window.isMobile判斷到．導致iPad畫面小轉大(直轉橫)時，螢幕卻依舊判斷小於 960，Header 沒算到高度跑版
		? 0
		: window.innerWidth - document.documentElement.clientWidth;

	var widthWithScrollBar = $(window).width() + scrollBarWidth;
	
	var useRwSizeNow = (widthWithScrollBar <= width) && ($("div.topBg").hasClass("Rwd"));
	//確認現在是否使用小版的rwd樣式
	return useRwSizeNow;
}


//unicode js 轉碼
function UnicodeToUtf8(unicode) {
	var uchar;
	var utf8str = "";
	var i;
	
	for(i=0; i<unicode.length;i+=2){			
		uchar = (unicode[i]<<8) | unicode[i+1];				//UNICODE为2字节编码，一次读入2个字节
		utf8str = utf8str  + String.fromCharCode(uchar);	//使用String.fromCharCode强制转换
	}
	return utf8str;
}


function Utf8ToUnicode(strUtf8) {
	var i, j;
	var uCode;
	var temp = new Array();

	for (i = 0, j = 0; i < strUtf8.length; i++) {
		uCode = strUtf8.charCodeAt(i);
		if (uCode < 0x100) { //ASCII字符
			temp[j++] = 0x00;
			temp[j++] = uCode;
		} else if (uCode < 0x10000) {
			temp[j++] = (uCode >> 8) & 0xff;
			temp[j++] = uCode & 0xff;
		} else if (uCode < 0x1000000) {
			temp[j++] = (uCode >> 16) & 0xff;
			temp[j++] = (uCode >> 8) & 0xff;
			temp[j++] = uCode & 0xff;
		} else if (uCode < 0x100000000) {
			temp[j++] = (uCode >> 24) & 0xff;
			temp[j++] = (uCode >> 16) & 0xff;
			temp[j++] = (uCode >> 8) & 0xff;
			temp[j++] = uCode & 0xff;
		} else {
			break;
		}
	}
	temp.length = j;
	return temp;
}

function jsonEqual(a, b) {
	return JSON.stringify(a) === JSON.stringify(b);
}

function unixTimToDataTime(unixtimestamp) {

	var result = unixtimestamp;

	if (typeof (unixtimestamp) !== 'undefined') {
		// Convert timestamp to milliseconds
		var date = new Date(unixtimestamp * 1000);
		// Year
		var year = date.getFullYear();
		// Month
		var month = date.getMonth() + 1;
		// Day
		var day = date.getDate();
		// Hours
		var hours = date.getHours();
		// Minutes
		var minutes = "0" + date.getMinutes();
		// Seconds
		var seconds = "0" + date.getSeconds();
		// Display date time in MM-dd-yyyy h:m:s format
		result = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
	}

	return result;
}

function getFormattedTime(time) {

	var d = typeof (time) !== "undefined"
		? time
		: new Date();
	// 換算現在時區
	var nowZone = (d.getTimezoneOffset() / (-60));
	var extraStamp = (nowZone - 8) * 60 * 60 * 1000;
	var nowTimeStamp = new Date().getTime() - extraStamp;
	//return (nowTimeStamp);
	var date = new Date(nowTimeStamp);
	var month = date.getMonth() + 1;
	if (month.toString().length === 1) {
		month = "0" + month;
	}
	var days = date.getDate();
	if (days.toString().length === 1) {
		days = "0" + days;
	}
	var hours = date.getHours();
	// Minutes part from the timestamp
	var minutes = "0" + date.getMinutes();
	// Seconds part from the timestamp
	var seconds = "0" + date.getSeconds();
	var formattedTime = date.getFullYear() + "/" + month.toString() + "/" + days.toString() + " "
		+ hours.toString() + ":" + minutes.substr(-2).toString() + ":" + +seconds.substr(-2).toString();
	return formattedTime;
}

var goTop = function () {
	var $body = (window.opera) ? (document.compatMode === "CSS1Compat" ? $('html') : $('body')) : $('html,body');
	$body.stop().animate({
			scrollTop: 0
		},
		600);
};

var getUrlNoCountryCode = function (countryCode) {
	var url = location.pathname;
	if (typeof (location.pathname) !== 'undefined') {
		var urls = url.split("/");
		var arrUrl = [];
		urls.forEach(function (item) {
			if (item !== "") {
				if (item !== countryCode) {
					arrUrl.push(item.toLowerCase());
				}
			}
		});
		if (arrUrl.length > 0) {
			url = arrUrl.join('/');
		}
	}
	return url;
};

var CheckWebsiteUnder960 = function () {
	//var result = false;
	//result = !$("#header-bar").find("#menu-main-mobile").is(":hidden");
	//return result;
	return CheckUseRWDsizeNow(960);
}


var IsDuringEventTime = function (type) {
	if (typeof (type) === "undefined") {
		type = "ArticleSolution";
	}
    var result = false;
    if (typeof (window.EventInfo) !== 'undefined') {
		var eventInfo = window.EventInfo[type];
        var today = getFormattedTime();
        if (typeof (today) !== "undefined") {
            today = new Date(today);
        }
        var startTime = eventInfo.StartData === ""
            ? today
			: eventInfo.StartData;
		var endTime = eventInfo.EndData;

		if (typeof (startTime) !== 'undefined' && typeof (endTime) !== 'undefined') {
			if (today < Date.parse(endTime).valueOf()) {
				if (Date.parse(startTime).valueOf() <= today ) {
					result = true;
				}
            }
        }
    }
    return result;
}